import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

const documentAPI = axios.create({
  baseURL: `${API_BASE}/api/documents`,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

export const uploadDocumentFile = async (authToken, file) => {
  const formData = new FormData();
  formData.append("document", file);

  return documentAPI.post("/upload", formData, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": "multipart/form-data",
    },
  });
};
